// This file was auto generated by resource-sync tools.

import en_brand_assets_inner_web from './en/brand_assets_inner_web.json';
import zh_brand_assets_inner_web from './zh/brand_assets_inner_web.json';


const resources = {
    'namespaces': 
    [{"localeInfos":[{"locale":"en","version":1},{"locale":"zh","version":1}],"i18nConfig":{"apiKey":"da99ed7e00ec461b83cb4afb445f8d63","projectId":54,"namespaceId":"rhhqziwfp2","namespaceName":"brand_assets_inner_web"}}],
    'en': {
        brand_assets_inner_web: en_brand_assets_inner_web
    },
    'zh': {
        brand_assets_inner_web: zh_brand_assets_inner_web
    }
};

export default resources;